import React from "react";

const AR_WEEKDAYS = ["أحد", "اثنين", "ثلاثاء", "أربعاء", "خميس", "جمعة", "سبت"];
const HeadAr = () => (
  <thead style={{ direction: "ltr" }}>
    <tr style={{ display: "flex", flexDirection: "row", direction: "ltr" }}>
      {AR_WEEKDAYS.map((w) => (
        <th
          key={w}
          scope="col"
          className="text-muted-foreground rounded-md font-normal text-[0.8rem]"
          style={{ width: "2rem", textAlign: "center" }}
        >
          {w}
        </th>
      ))}
    </tr>
  </thead>
);
const calendarComponents = { Head: HeadAr };
const calendarRowClass = { row: "flex w-full mt-2 flex-row" };


const fmt = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso);
  // Iteration 75 — Force Gregorian calendar in the admin tables. iOS/iPad
  // Safari defaults `ar-SA` to the Islamic (Hijri) calendar, which caused
  // bookings / purchases dates to appear in Hijri on mobile/iPad while
  // desktop showed Gregorian. Both the locale extension `-u-ca-gregory`
  // and the explicit `calendar: "gregory"` option are set for maximum
  // engine coverage (older Safari ignores one or the other).
  return d.toLocaleString("ar-SA-u-ca-gregory", {
    calendar: "gregory",
    weekday: "short",
    day: "numeric",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });
};


// Friendly Arabic date+time used by the backup status indicator and book status.
// Example output: "05 مايو 2026 - 03:30 م"
const formatArabicDateTime = (iso) => {
  if (!iso) return "";
  try {
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return "";
    const datePart = d.toLocaleDateString("ar-EG", {
      day: "2-digit",
      month: "long",
      year: "numeric",
    });
    const timePart = d.toLocaleTimeString("ar-EG", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
    return `${datePart} - ${timePart}`;
  } catch {
    return iso;
  }
};


const STATUS_LABELS = {
  pending: "بانتظار الدفع",
  confirmed: "مؤكدة",
  canceled: "ملغاة",
  failed: "فشل الدفع",
  completed: "منتهية",
  paid: "مدفوع",
};


const HOUR_OPTIONS = [10, 11, 12, 13, 14, 15, 16, 17];


const blockDisabledDates = (d) => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  if (d < today) return true;
  const dow = d.getDay();
  if (dow === 5 || dow === 6) return true;
  return false;
};



const PAGE_SIZE = 20;

export { AR_WEEKDAYS, HeadAr, calendarComponents, calendarRowClass, fmt, formatArabicDateTime, STATUS_LABELS, HOUR_OPTIONS, blockDisabledDates, PAGE_SIZE };
